import React, { useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import AuthContext from '../contexts/AuthContext'
import { NavDropdown } from 'react-bootstrap'
import { KEYS } from './Auth'

export default function ProfileNav(props) {
  const profile = useContext(AuthContext)
  const refreshToken = localStorage.getItem(KEYS.REFRESH_TOKEN)
  const accessToken = localStorage.getItem(KEYS.ID_TOKEN)

  function getApiKey() {
    // Create the object to be copied into Python/R/etc..
    const data = `{"access_token": "${accessToken}", "refresh_token": "${refreshToken}"}`
    // Copy the data to clipboard to paste int Python/R/etc..
    navigator.clipboard.writeText(data)
  }

  if (!profile) return null
  return (
    <NavDropdown id="sb-nav-profile" className="no-carrot" alignRight title={
      <FontAwesomeIcon icon={faUser} fixedWidth />
    }>
      <NavDropdown.Header title="My Account (myUSGS)">
        <strong>{(profile.tokenParsed && profile.tokenParsed.name) || 'Error: Missing Username'}</strong><br/>
        {(profile.tokenParsed && profile.tokenParsed.preferred_username) || 'Error: Missing Preferred Name'}<br/>
      </NavDropdown.Header>
      <NavDropdown.Item onClick={() => {getApiKey()}}>Copy API Token</NavDropdown.Item>
      <NavDropdown.Item id="profile-logout" title="Log out" onClick={() => {profile.logout()}}>
        <FontAwesomeIcon icon={faSignOutAlt} fixedWidth />Log out
      </NavDropdown.Item>
    </NavDropdown>
  )
}
